<template>
<div>
<v-app style="background:#D6CCA9">
    <!-- <v-navigation-drawer
      v-model="drawer"
      color="rgb(253,253,253,0.7)"
      app
      class="d-flex d-md-none"
    >
      <v-list dense>
        <v-list-item v-for="(t, i) in tabs" :key="i" link :to='t.path'>
          <v-list-item-action>
            <v-icon>{{t.icon}}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{t.title}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer> -->

    <v-app-bar
      app
      color="#5A272C"
      dark
    >
     <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="d-flex d-md-none"/> -->
      <v-toolbar-title contain>
        <v-img
            src="@/blindhopewhitettranscropped.png"
            width="50px"
          ></v-img>
          </v-toolbar-title>
        <v-toolbar-title contain style="color:rgb(230,230,230)">
          &nbsp;Bees of Our Lady of Blind Hope
        </v-toolbar-title>

        <v-spacer/>
      <!--<v-toolbar-items class="d-none d-md-flex">
        <v-btn color="rgb(20,20,20)" v-for="(t, i) in tabs" :key="i" text :to='t.path'>{{t.title}}</v-btn>
      </v-toolbar-items>-->
    </v-app-bar>

    <v-content style="background:transparent">
        <router-view/>
    </v-content>

    <v-footer
    app
    color="#5A272C"
    dark>
    <div style="text-align:center;margin:auto;max-width:70%">
      <v-btn class="ma-2" outlined color="rgb(230,230,230)"
        :href="'mailto: workers@beesofhope.org'">
          workers@beesofhope.org
      </v-btn>
    </div>
    </v-footer>
  </v-app>
</div>
</template>

<script>
  export default {
    name: 'app',
    props: {
      source: String,
    },
    data: () => ({
      drawer: false,
      tabs: [],
      tabs_bkp: [
        {
        title: "Infos",
        path: "/",
        icon: "mdi-account-arrow-right-outline"
       },
        {
        title: "Galerie",
        path: "/galerie",
        icon: "mdi-bookshelf"
        },
      ]
    }),
  }
</script>

<style scoped>
.bgImg { 
  background: url('BG_1600XY.jpeg') no-repeat center center fixed;
  -webkit-background-size: center;
  -moz-background-size: center;
  -o-background-size: center;
  background-size: center;
  max-width: 100%
}
.bgImgOld { 
  background: url('BG_1600XY.jpeg') no-repeat center center fixed; 
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%;
  max-width: 100%;
  overflow: hidden;
}
</style>
